import { ReactNode } from 'react';
import { SvgIcon } from '@mui/material';
import HomeSmileIcon from '../../icons/untitled-ui/duocolor/home-smile';
import { paths } from '../../paths';
import ReceiptCheck from 'src/icons/untitled-ui/duocolor/receipt-check';
import FileCheck01 from 'src/icons/untitled-ui/lineicons/file-check-01';
import BookOpen01 from '@untitled-ui/icons-react/build/esm/BookOpen01';

interface Item {
  disabled?: boolean;
  icon?: ReactNode;
  items?: Item[];
  label?: ReactNode;
  path?: string;
  title: string;
}

export interface Section {
  items?: Item[];
  subheader?: string;
}

const component =
  process.env.NODE_ENV === 'development'
    ? {
        subheader: 'Development Kit',
        items: [
          {
            title: 'Component',
            path: paths.components.index,
            icon: (
              <SvgIcon fontSize="small">
                <ReceiptCheck />
              </SvgIcon>
            ),
            items: [
              {
                title: 'DataDisplay',
                items: [
                  {
                    title: 'Detail Lists',
                    path: paths.components.dataDisplay.detailLists
                  },
                  {
                    title: 'Tables',
                    path: paths.components.dataDisplay.tables
                  },
                  {
                    title: 'Quick Start',
                    path: paths.components.dataDisplay.quickStats
                  }
                ]
              },
              {
                title: 'Lists',
                items: [
                  {
                    title: 'Grouped Lists',
                    path: paths.components.lists.groupedLists
                  },
                  {
                    title: 'Grid Lists',
                    path: paths.components.lists.gridLists
                  }
                ]
              },
              {
                title: 'Forms',
                path: paths.components.forms
              },
              {
                title: 'Overlays',
                path: paths.components.modals
              },
              {
                title: 'Charts',
                path: paths.components.charts
              },
              {
                title: 'Components',
                items: [
                  {
                    title: 'Buttons',
                    path: paths.components.buttons
                  },
                  {
                    title: 'Typography',
                    path: paths.components.typography
                  },
                  {
                    title: 'Colors',
                    path: paths.components.colors
                  },
                  {
                    title: 'Inputs',
                    path: paths.components.inputs
                  }
                ]
              }
            ]
          }
        ]
      }
    : {};

export const useSections = () => {
  // const { t } = useTranslation();

  let menu: Section[] = [
    {
      subheader: 'Menu',
      items: [
        {
          title: '메인화면',
          path: paths.dashboard.index,
          icon: (
            <SvgIcon fontSize="small">
              <HomeSmileIcon />
            </SvgIcon>
          )
        },
        // {
        //   title: '정산 정보',
        //   path: paths.dashboard.rewards,
        //   icon: (
        //     <SvgIcon fontSize="small">
        //       <ReceiptCheckIcon />
        //     </SvgIcon>
        //   )
        // },
        {
          title: '이용 메뉴얼',
          path: paths.dashboard.manual,
          icon: (
            <SvgIcon fontSize="small">
              <BookOpen01 />
            </SvgIcon>
          )
        },
        {
          title: '이용약관/운영정책',
          path: paths.dashboard.terms,
          icon: (
            <SvgIcon fontSize="small">
              <FileCheck01 />
            </SvgIcon>
          )
        }
        // ...fullMenu
      ]
    },
    // {
    //   subheader: 'No Permissions',
    //   items: []
    // },
    component
  ];

  return menu;
};
